/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetStatsByDateQueryResponse, GetStatsByDateQueryParams, GetStatsByDate400 } from '../entities/GetStatsByDate'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getStatsByDate } from '../api/getStatsByDate'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getStatsByDateQueryKey = (params: GetStatsByDateQueryParams) => [{ url: '/stats/by-date' }, ...(params ? [params] : [])] as const

export type GetStatsByDateQueryKey = ReturnType<typeof getStatsByDateQueryKey>

export function getStatsByDateQueryOptions(params: GetStatsByDateQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getStatsByDateQueryKey(params)
  return queryOptions<GetStatsByDateQueryResponse, ResponseErrorConfig<GetStatsByDate400>, GetStatsByDateQueryResponse, typeof queryKey>({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getStatsByDate(params, config)
    },
  })
}

/**
 * @description Get stats by date
 * @summary Get stats by date
 * {@link /stats/by-date}
 */
export function useGetStatsByDate<
  TData = GetStatsByDateQueryResponse,
  TQueryData = GetStatsByDateQueryResponse,
  TQueryKey extends QueryKey = GetStatsByDateQueryKey,
>(
  params: GetStatsByDateQueryParams,
  options: {
    query?: Partial<QueryObserverOptions<GetStatsByDateQueryResponse, ResponseErrorConfig<GetStatsByDate400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getStatsByDateQueryKey(params)

  const query = useQuery(
    {
      ...(getStatsByDateQueryOptions(params, config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetStatsByDate400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}